import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CONFIGURATION } from '@environments/app.constants';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { BehaviorSubject } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService } from '@services/localization.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule } from '@angular/forms';

@Component({
  selector: 'account-download-component',
  templateUrl: '../sharedTemplates/account-download.component.html',
})
export class AccountDownload implements OnInit, AfterViewInit {
  IsReLogin = false;
  reloginDatas: UntypedFormGroup;
  reloginDataRaw: any;
  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private _FormBuilder: UntypedFormBuilder,
    private _UserHelper: UserHelper
  ) {
    this.reloginDatas = _FormBuilder.group({
      userName: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(2)]),
      userPassword: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(5)]),
    });
  }
  ngOnInit() {
    this.reloginDatas.valueChanges.subscribe(x => {
      this.reloginDataRaw = x;
    });
  }
  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setNavbarTitle('Document_Download', false);
  }
  dwnPersonal() {
    window.location.href = '/API/DownloadPersonalInfo';
  }
  dwnBookings() {
    window.location.href = '/API/DownloadBookings/' + this._LocalizationService.LANGID;
  }
  dwnSlips() {
    window.location.href = '/API/DownloadSlips/' + this._LocalizationService.LANGID;
  }
  dwnDocuments() {
    window.location.href = '/API/DownloadDocuments';
  }
  dwnSupportMessage() {
    window.location.href = '/API/DownloadSupportMessage';
  }

  submitLoginData() {
    const translator = new TranslatePipe(this._LocalizationService);
    this._ApiService.signIn(this.reloginDataRaw).then(result => {
      if (result.code == '') {
        return 'error|System Error';
      } else {
        if (result.code == 'success') {
          this.IsReLogin = true;
        } else if (result.code == 'success1') {
          this.IsReLogin = true;
        }
      }
    });
  }
}
